import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full mb-3">
            剧集分类
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            剧集专题索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按类型和主题快速找到你喜欢的电视剧分类
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-200/60 transition-all text-center cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-primary-50 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-primary-500 text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 font-heading whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-400 mb-2">{item.desc}</p>
              <span className="text-xs font-bold text-primary-600">
                {item.count}部
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}